<template>
  <v-card>
    <v-data-table
      v-bind="computedProps"
      v-on="$listeners"
      sort-by="_id"
      sort-desc
      hide-default-header
    >
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th
              v-for="h in headers"
              :key="h.id"
              class="white--text text-center"
              :class="color"
            >
              <span>{{ h.text }}</span>
            </th>
          </tr>
        </thead>
      </template>

      <!-- pass through scoped slots -->
      <template
        v-for="(_, scopedSlotName) in $scopedSlots"
        v-slot:[scopedSlotName]="slotData"
      >
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>

      <!-- pass through normal slots -->
      <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
        <slot :name="slotName" />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { VDataTable } from "vuetify/lib";

export default {
  name: "SDataTable",
  extends: VDataTable,
  props: {
    color: {
      type: String,
      default: "primaryColor",
    },
  },
  computed: {
    computedProps() {
      return {
        ...this.$props,
      };
    },
  },
};
</script>

<style></style>
